import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { HeroCanvas } from './HeroCanvas';
import { AnalyticsArt } from './illustrations';

/**
 * The /features hero.
 *
 * This is the home hero's CANVAS carrying the features page's own words —
 * that split is the whole point of the component. An earlier version also
 * imported the home hero's furniture: a six-item check rail, a second
 * "Book a demo" button and a beta-points rail, none of which this page had
 * asked for. The result read as the home page with the headline swapped.
 *
 * What belongs here is exactly what the old PageHero carried — eyebrow,
 * two-line title, one paragraph, one action — and nothing else. Anything
 * added beyond that is the home page's pitch, not this page's.
 *
 * The words themselves are the pre-redesign ones, restored on request from
 * commit 2e82a11. They are set in this canvas's own type scale rather than
 * that version's — sentence case across the two lines, because
 * .display-accent is a colour change and title case on top of it says the
 * same thing twice.
 */
const FeaturesHero = () => (
  <HeroCanvas>
    <div className="grid items-center gap-14 lg:grid-cols-[1.15fr_0.85fr] lg:gap-10">
      <div>
        <span className="eyebrow accent-brand animate-fade-up">
          <span className="spark-mark" aria-hidden="true" />
          Platform features
        </span>

        <h1 className="display-heading mt-6 animate-fade-up" style={{ animationDelay: '70ms' }}>
          <span className="display-solid block">Powerful features for</span>
          <span className="display-accent block">modern sales teams</span>
        </h1>

        <p
          className="mt-6 max-w-xl text-lede leading-relaxed text-content-muted animate-fade-up"
          style={{ animationDelay: '140ms' }}
        >
          Everything you need to supercharge your calling operations and close more deals.
        </p>

        <div className="mt-9 animate-fade-up" style={{ animationDelay: '200ms' }}>
          <Link to="/contact" className="btn-pill btn-pill--primary">
            Start free beta
            <ArrowRight className="h-[18px] w-[18px]" />
          </Link>
        </div>
      </div>

      {/* The phone belongs to the home hero — it is that page's one object,
          and repeating it here made the two pages open identically.

          .accent-5 rather than the page's brand accent: the illustration
          draws in --accent / --accent-alt, and violet is the hue the panel
          it sits on falls away to, so the art resolves against its ground
          instead of competing with it. The scene brings its own light paper
          plane, so it reads as a lit surface on the dark panel. */}
      <div
        className="accent-5 flex animate-fade-in justify-center"
        style={{ animationDelay: '180ms' }}
      >
        <AnalyticsArt className="h-auto w-full max-w-md" />
      </div>
    </div>
  </HeroCanvas>
);

export default FeaturesHero;
